<mat-tab-group class="sub-tab-group" animationDuration="0ms" disableRipple="true">
  <mat-tab class="tab-small" *lmsProfileGuard="'techTests.create'" label="create">
    <ng-template mat-tab-label>{{ 'techTests.create.scopeLabel' | translate }}</ng-template>
    <ng-template matTabContent>
      <h5>{{ 'techTests.create.instructions.title' | translate }}</h5>
      <div [innerHtml]="'techTests.create.instructions.paragraph' | translate"></div>
      <lms-dynamic-form
        [action]="'techTests.create'"
        [questions]="questions"
        (submit)="createTests($event)"
        [options]="{ showSpinnerUponSubmitting: false }"
      >
      </lms-dynamic-form>
    </ng-template>
  </mat-tab>

  <mat-tab *lmsProfileGuard="'techTests.list'" label="results">
    <ng-template mat-tab-label>{{ 'techTests.results.scopeLabel' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-toolbar [options]="toolbarConfig"></lms-toolbar>
      <div class="gl-table__container">
        <gl-table
          [id]="listId"
          [dataSource]="dataSource"
          data-testid="techTestTable"
          [placeholder]="'actions.noResultTable' | translate"
          paginator
          (onDatasourceUpdate)="onDatasourceUpdate($event.detail.dataSource)"
        >
        </gl-table>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
